export enum ProductGroup {
	PAKETY_USLUG = 'pakety-uslug',
	SBER_TELECOM = 'sber-telekom',
	AKKREDITIV = 'akkreditiv',
	KREDITY = 'kredity',
	VED = 'ved',
	LIZING = 'lizing',
	EKVAYRING = 'ekvayring',
	SERVIS_PROVERKI_KONTRAGENTOV = 'servis-proverki-kontragentov',
	SAMOZANYATYE = 'samozanyatye',
	NAVIGATOR_MSP = 'navigator-msp',
	OTHER = 'other',
}

export const ProductGroupTranslate = {
	[ProductGroup.PAKETY_USLUG]: 'Пакеты услуг',
	[ProductGroup.SBER_TELECOM]: 'Сбер-телеком',
	[ProductGroup.AKKREDITIV]: 'Аккредитив',
	[ProductGroup.KREDITY]: 'Кредиты',
	[ProductGroup.VED]: 'ВЭД',
	[ProductGroup.LIZING]: 'Лизинг',
	[ProductGroup.EKVAYRING]: 'Эквайринг',
	[ProductGroup.SERVIS_PROVERKI_KONTRAGENTOV]: 'Сервис проверки контрагентов',
	[ProductGroup.SAMOZANYATYE]: 'Самозанятые',
	[ProductGroup.NAVIGATOR_MSP]: 'Поддержка МСП',
	[ProductGroup.OTHER]: 'Прочее',
}
